import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class DeductionInfoSpouseComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/spouse/:spouseId/b2c/deduction-info/:step';
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, null, step);
  }
}
